import { useCallback } from "react";
import { normalizeSectionNameOrDefault } from "@/utils/sectionNaming";

export type PopulateSectionNameOnEmptyArgs = {
  /**
   * Raw input value from the field.
   * If this is empty (after trim), we will auto-populate it.
   */
  value?: string | null;
  /** Usually product name (or any base section name). */
  baseName?: string | null;
  /**
   * 0-based active tab index (e.g. activeSectionIndex).
   * Auto-populated name will be "<baseName> <activeTabIndex+1>".
   */
  activeTabIndex?: number | null;
};

export type UsePopulateSectionNameOnEmptyOptions = {
  /** Max length to persist into state. Defaults to 190 (matches existing patterns). */
  maxLength?: number;
};

/**
 * Hook that normalizes the "Section Name" input:
 * - When user clears the field -> show the unified default "Untitled"
 * - Otherwise -> keep the typed value (hard-capped)
 */
export function usePopulateSectionNameOnEmpty(opts?: UsePopulateSectionNameOnEmptyOptions) {
  const maxLength =
    typeof opts?.maxLength === "number" && Number.isFinite(opts.maxLength) && opts.maxLength > 0
      ? opts.maxLength
      : 190;

  return useCallback(
    ({ value }: PopulateSectionNameOnEmptyArgs): string => {
      return normalizeSectionNameOrDefault(value, { maxLength });
    },
    [maxLength]
  );
}


